import * as React from 'react';
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import IconButton from '@mui/material/IconButton';
import MenuIcon from '@mui/icons-material/Menu';
import { AccountCircle,ShoppingCartCheckout } from '@mui/icons-material';
import SearchIcon from '@mui/icons-material/Search';
import FilterAltIcon from '@mui/icons-material/FilterAlt';
import BottomNavigation from '@mui/material/BottomNavigation';
import BottomNavigationAction from '@mui/material/BottomNavigationAction';
import { useNavigate } from 'react-router-dom';

// import { AccountCircle, Home, ShoppingCartCheckout } from '@mui/icons-material';
export default function ButtonAppBar() {
  const navigate = useNavigate();
  const [seachValue, setSeachValue] = React.useState("");
  
  return (
    <Box sx={{ flexGrow: 1 ,zIndex:100}} className>
      <AppBar position="static" sx={{zIndex:100}}>
        <Toolbar>
          
          <Typography className = " d-none d-md-block" variant="h6" component="div" sx={{ flexGrow: 3 }} >
          <Typography className = " d-none d-md-block" variant="h6" component="div"  >
            ASVmall
          </Typography>
          </Typography>
          <Typography className = " d-block d-md-none"  variant="h6" component="div" sx={{ flexGrow: 3 }} >
          <Typography className = " d-block d-md-none"  variant="h6" component="div" >
            ASV
          </Typography>
          </Typography>
          {/* <IconButton size="large"  href="/Profiles"  sx={{ flexGrow: 3 ,textAlign:"start"}} >
            ASVmall
          </IconButton> */}
          
          <div className="search-bar-div">

<span class="input-group-text" id="basic-addon1"><SearchIcon /></span>
<input type="search" class="form-control search-bar" placeholder="search here...."
  // aria-label="searchbar" aria-describedby="basic-addon1" onChange={e => setSeachValue(e.target.value)} />
  
  aria-label="searchbar" aria-describedby="basic-addon1" onChange={e => navigate(`/viewproducts/${e.target.value}`)} />



</div>
          <IconButton size="large "  className="pe-0 pe-md-3"  onClick={()=> navigate("/cart")} aria-label="search" color="inherit">
            <ShoppingCartCheckout />
          </IconButton>
          <IconButton size="large "   className="ps-2" onClick={()=> navigate("/Profiles")} aria-label="search" color="inherit">
            <AccountCircle />
          </IconButton>
          {/* <BottomNavigationAction label="Home" value="" icon={<AccountCircle />} />/ */}
          {/* <Button  href="/Profiles" label="Profile" color="inherit"><AccountCircle /></Button> */}
        </Toolbar>
      </AppBar>
    </Box>
  );
}